export const sidebar = {
  dashboard: 'Dashboard',
  aiPersonality: 'AI Voice Personality',
  callTasks: 'Call Tasks',
  phoneRecords: 'Phone Records',
  outboundRecords: 'Outbound Records',
  inboundRecords: 'Inbound Records',
  templates: 'Script Templates',
  analytics: 'Analytics Report',
  billing: 'Account Details',
  notifications: 'Important Notifications',
};
